/**
 * @generated
 * This file is generated by scripts/generate-async-query-metadata.js.
 * Do not edit manually.
 * Source: src/ui/search-page-relay/right-panel/__generated__/rightPanelAsyncQuery.graphql.ts
 */

export const RIGHT_PANEL_ASYNC_QUERY_PERSISTED_ID = 'e0b1d5f59b43a909539c14bed4b7b0c5610868820fd8e2cbd584e955af371ad0';
export const RIGHT_PANEL_ASYNC_QUERY_OPERATION_NAME = 'rightPanelAsyncQuery';
